module.exports = __webpack_public_path__ + "static/media/icon-establishment-car-wash.c6e43cc5.svg";